import React from 'react';
import { IModuleRoute, IRoute } from '../models';

export function flatRoutes(moduleRoute: IModuleRoute): IRoute[] {
	const basePath = moduleRoute.path;
	return [
		{
			path: basePath,
			name: moduleRoute.name,
			requiredRoles: moduleRoute.requiredRoles,
		},
		...moduleRoute.nested.map(({ name, path, requiredRoles }) => ({
			path: basePath + path,
			name,
			requiredRoles,
		})),
	];
}

export function addComponentsToPageRoutesList(
	pageRoutesList: IModuleRoute,
	componentToRender: Record<string, React.ElementType>,
) {
	return flatRoutes(pageRoutesList)
		.map((route) => ({
			...route,
			Component: componentToRender[route.name],
		}))
		.filter((route) => !!route.Component);
}
